module.exports = __webpack_public_path__ + "img/tsun.28cdc6d7.png";